export const defaultProps = {
	highGain: 0,
	lowGain: 0,
	midGain: 0,
};

export type Props = typeof defaultProps;
